import React from 'react';
import { CTA } from '../../../components';

const ParagraphCTAReference = ({ entity }) => {
  const BlockContent = entity.getIn(['field_content_block_reference', '0', 'entity']);
  const text = BlockContent.getIn(['field_text', '0', 'value']);
  const title = BlockContent.getIn(['field_title', '0', 'value']);
  const image = BlockContent.getIn(['field_image', '0']);
  const link = BlockContent.get('field_link');

  return (
    <div className="Paragraph ParagraphCTAReference">
      <CTA
        title={title}
        text={text}
        image={image}
        link={link}
      />
    </div>
  );
};

export default ParagraphCTAReference;
